var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"map",attrs:{"id":"map"}}),_c('div',{staticClass:"card-container-map"},[_c('CardVue',{attrs:{"title":_vm.title,"text":_vm.text}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }